import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DeliverPersonalizationImage from './DeliverPersonalizationImage'

const copy = {
  heading: `Powerful data-driven personalization`,
  description: `Customers want to connect with businesses in the same way they chat with their friends and family—with fast, simple, and convenient messaging.`,
}

const boxes = [
  {
    headline: `Deliver a 1:1 personalized experience`,
    content: `Combining the power of native Customer Data Platform (CDP) with native WhatsApp helps marketers create more meaningful 1:1 customer conversations.`,
  },
  {
    headline: `Actionable data at your fingertips`,
    content: `Own and activate your data to craft engaging WhatsApp experiences that are truly personalized to each individual customer.`,
  },
  {
    headline: `Save time with dynamic, universal audiences`,
    content: `Build audiences based on real-time data and dynamically leverage it for WhatsApp and all your other connected tools so that you’re always sending the right message to the right person at the right time.`,
  },
]

const DeliverPersonalization: FC = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
        <ColumnTrackWrapper>
          <ColumnTrack gap="medium">
            {boxes.map(({ headline, content }) => (
              <FeatureBoxBase alignment="left" key={headline}>
                <FeatureBox.Body>
                  <FeatureBox.Title>{headline}</FeatureBox.Title>
                  <FeatureBox.Text>{content}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </SectionCopy>
      <Section.Contents>
        <DeliverPersonalizationImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default DeliverPersonalization

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
  direction: ltr;
`
